import { Injectable, TemplateRef } from '@angular/core';
import { MatConnectedDialog, MatConnectedDialogMobileAnimation } from '../../service/connected-dialog';
import { LocaleService } from '../../service/locale.service';
import { CsConfirmPopupComponent } from './cs-confirm-popup/cs-confirm-popup.component';

export interface IConfirmDialogOptions {
  type?: 'success' | 'error' | 'info';
  header: string;
  title?: string;
  message?: string | Array<string>;
  cancelText?: string;
  confirmText?: string;
  color?: 'primary' | 'accent' | 'danger';
  textAlign?: 'left' | 'center';
  disableClose?: boolean;
  confirmCallback?: (data?: unknown) => void;
  cancelCallback?: (data?: unknown) => void;
  customizedConfirmButton?: TemplateRef<any>;
}

export interface IOneBtnDialogOptions {
  header: string;
  type?: 'success' | 'error' | 'info';
  title?: string;
  message?: string | Array<string>;
  confirmText?: string;
  color?: 'primary' | 'accent' | 'danger';
  textAlign?: 'left' | 'center';
  disableClose?: boolean;
  confirmCallback?: (data?: unknown) => void;
  cancelCallback?: (data?: unknown) => void;
  customizedConfirmButton?: TemplateRef<any>;
}

@Injectable({ providedIn: 'root' })
export class CsPopupService {
  public constructor(
    protected readonly matConnectedDialog: MatConnectedDialog,
    private localeService: LocaleService,
  ) {}

  public confirm(options: IConfirmDialogOptions) {
    const {
      type = 'info',
      header,
      title,
      message,
      cancelText = this.localeService.getValue('go_back_2'),
      confirmText = this.localeService.getValue('confirm'),
      color = 'primary',
      textAlign = 'left',
      disableClose = false,
      confirmCallback = () => {},
      cancelCallback = () => {},
      customizedConfirmButton,
    } = options;

    const dialogRef = this.matConnectedDialog.open(CsConfirmPopupComponent, {
      data: {
        type,
        header,
        title,
        message,
        cancelText,
        confirmText,
        color,
        textAlign,
        confirmCallback,
        cancelCallback,
        customizedConfirmButton,
      },
      disableClose,
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
    return dialogRef;
  }

  public success(options: IConfirmDialogOptions) {
    return this._oneBtnDialog({ ...options, type: 'success' });
  }

  public error(options: IConfirmDialogOptions) {
    return this._oneBtnDialog({ ...options, type: 'error' });
  }

  public info(options: IConfirmDialogOptions) {
    return this._oneBtnDialog({ ...options, type: 'info' });
  }

  private _oneBtnDialog(options: IOneBtnDialogOptions) {
    const {
      header,
      type,
      title,
      message,
      confirmText = this.localeService.getValue('close'),
      color = 'primary',
      textAlign = 'center',
      disableClose = false,
      confirmCallback = () => {},
      cancelCallback = () => {},
      customizedConfirmButton,
    } = options;

    const dialogRef = this.matConnectedDialog.open(CsConfirmPopupComponent, {
      data: {
        header,
        type,
        title,
        message,
        confirmText,
        color,
        textAlign,
        confirmCallback,
        cancelCallback,
        customizedConfirmButton,
      },
      disableClose,
      mobileAnimation: MatConnectedDialogMobileAnimation.SLIDE_UP,
      mobileFixedBottom: true,
    });
    return dialogRef;
  }
}
